import { useEffect } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { Button, EmptyState } from '@/components';
import { reportError } from '@/lib/analytics';
import { t } from '@/i18n';

/** Rendered by the router when a route throws or a path does not match. */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  // A route that failed to load, or threw while rendering, is a crash the
  // learner did not cause; it is reported (only if they opted in). A missing
  // page is not.
  useEffect(() => {
    if (notFound) return;
    reportError(error, { where: 'route' });
    if (import.meta.env.DEV) console.error('[route error]', error);
  }, [error, notFound]);

  return (
    <div className="grid min-h-dvh place-items-center bg-bg p-6">
      {/* Plan doc 16 gives the not-found page to Fifi. */}
      <EmptyState
        character="fifi"
        emotion="surprised"
        title={notFound ? t('error.notFoundTitle') : t('error.title')}
        body={notFound ? t('error.notFoundBody') : t('error.body')}
        action={<Button onClick={() => navigate('/learn')}>{t('error.goHome')}</Button>}
      />
    </div>
  );
}
